import { Box, Typography } from "@mui/material";

export default function DunsSummary(){
  return (
    <Box>
      <Typography variant="body1">
        Solicite um número DUNS para sua empresa, obrigatório para criar sua conta de desenvolvedor Apple.
      </Typography>
    </Box>
  )
}